// src/components/utils/sendInfobipTemplate.js

const SEND_TEMPLATE_URL = "https://sendinfobiptemplate-qwa7hlejia-uc.a.run.app";

/**
 * Llama a la Cloud Function sendInfobipTemplate
 * @param {Object} params
 * @param {string} params.to - teléfono del cliente (ej: "541155805083")
 * @param {string} params.from - número remitente (ej: "5491168404947")
 * @param {string} params.templateName - nombre del template Infobip
 * @param {string} [params.language="en"]
 */
export async function sendInfobipTemplate({ to, from, templateName, language = "en" }) {
    const res = await fetch(SEND_TEMPLATE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ to, from, templateName, language }),
    });

    let data = null;
    try {
        data = await res.json();
    } catch (e) {
        // ignore
    }

    if (!res.ok || !data?.ok) {
        return {
            ok: false,
            status: res.status,
            error: data?.error || `HTTP ${res.status}`,
            raw: data,
        };
    }

    return { ok: true, data };
}
